import styles from "./index.module.css";
import React from "react";
import classNames from "classnames";
import { ChevronsRight } from "react-ikonate";
import { useLocation, Link } from "react-router-dom";

import { PageNavState } from "./usePageNavState";

export default function Page({ children }) {
  return <div className={styles.page}>{children}</div>;
}

export function Content({ children, className }) {
  return (
    <div id="scrollableDiv" className={classNames(styles.content, className)}>
      {children}
    </div>
  );
}

export function Nav({ className, children }) {
  const { collapsed, setCollapsed } = PageNavState.useContainer();

  return (
    <nav
      className={classNames(styles.nav, className, {
        [styles.collapsed]: collapsed,
      })}
    >
      <ul className={styles.list}>{children}</ul>

      <button
        className={styles.collapseToggle}
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <ChevronsRight className={styles.collapseIcon} />

        <span className={styles.collapseLabel}>Collapse</span>
      </button>
    </nav>
  );
}

export function NavGroup({ title, children }) {
  return (
    <li className={styles.group}>
      <header>
        <span>{title}</span>
      </header>
      <ul className={styles.groupList}>{children}</ul>
    </li>
  );
}

export function NavItem({ icon, to, children, onClick, notification = null }) {
  const location = useLocation();
  const { collapsed } = PageNavState.useContainer();

  const isExternal = typeof to === "string" && to.startsWith("http");

  const handleClick = (e) => {
    if (isExternal) {
      e.preventDefault();
      window.location.href = to;
    } else if (onClick) {
      onClick(e);
    }
  };

  const isActive = location.pathname.startsWith(to);
  const title = typeof children === "string" ? children : "nav icon";

  return (
    <li
      className={classNames(styles.item, {
        [styles.active]: isActive,
        [styles.collapsed]: collapsed,
      })}
      key={to}
      onClick={handleClick}
    >
      <Link
        className={styles.itemLink}
        to={isExternal ? "#" : to}
        title={title}
      >
        {icon && (
          <div className={styles.itemIcon}>
            {icon}
            {collapsed && notification && notification !== 0 && (
              <span className={styles.notificationIcon}>{notification}</span>
            )}
          </div>
        )}

        {!collapsed && <span>{children}</span>}
      </Link>
    </li>
  );
}
